import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 20px;
  align-items: center;

  i {
    float: left;
  }

  h1 {
    margin-left: 0.7rem;
    font-size: 1.2rem;
    font-weight: 700;
  }

  > div {
    flex-direction: row;
    flex: 1;
    justify-content: flex-end;
    display: flex;

    button {
      display: flex;
      padding: 10px 20px 10px 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      margin-left: 5px;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      transition: all 0.5s ease;

      &:hover {
        background: #333 !important;
      }

      &.excel {
        background: #179d46;
      }

      &.pdf {
        background: #df4c2a;
      }

      &.sync {
        background: #4080e0ff;
      }

      div {
        display: flex;
        flex-direction: column;
        padding: 0 0 0 5px;

        h3 {
          font-size: 8px;
          text-align: left;
          font-weight: normal;
          color: #fff;
          margin: 0px;
        }

        h2 {
          font-size: 10px;
          text-align: left;
          color: #fff;
          margin: 0px;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    max-width: 100%;
    font-size: 1rem;
  }
`;
